<script>
	import { browser } from "$app/environment";
	import { slugify } from "cando-util";
	import { isValidPhoneNumber } from "libphonenumber-js";

	export let value;
	export let isValid = false;
	export let label = "new phone number";
	export let handleChange = () => {};
	export let disabled = false;
	export let readonly = false;
	export let tabindex = 0;
	export let key = "";
	export let itemId = "";

	const countries = [
		{
			code: "+1",
			name: "US",
			flag: "\u{1F1FA}\u{1F1F8}",
			format: (number) =>
				(number + "X".repeat(10))
					.slice(0, 10)
					.replace(/([0-9X]{3})([0-9X]{3})([0-9X]{4})/, "($1) $2-$3")
					.split("X")[0],
		},
		{
			code: "+52",
			name: "MX",
			flag: "\u{1F1F2}\u{1F1FD}",
			format: (number) =>
				(number + "X".repeat(10))
					.slice(0, 10)
					.replace(/([0-9X]{2})([0-9X]{4})([0-9X]{4})/, "($1) $2 $3")
					.split("X")[0],
		},
		{
			code: "+44",
			name: "GB",
			flag: "\u{1F1EC}\u{1F1E7}",
			format: (number) =>
				(number + "X".repeat(10))
					.slice(0, 10)
					.replace(/([0-9X]{2})([0-9X]{4})([0-9X]{4})/, "$1 $2 $3")
					.split("X")[0],
		},
		// Add more countries as needed
	];

	const getCountryCode = (phoneNumber) => {
		const codes = [...countries]
			.sort((a, b) => (a.code > b.code ? -1 : 1))
			.map((c) => c.code);
		for (const code of codes) {
			if ((phoneNumber || "").startsWith(code)) {
				return code;
			}
		}
		return codes[codes.length - 1];
	};

	const getCountryFormat = (code) => {
		const country = countries
			.sort((a, b) => (a.code > b.code ? -1 : 1))
			.find((c) => c.code === code);
		return country ? country.format : (num) => num;
	};

	const getFormattedNumber = (phoneNumber = "") => {
		const countryCode = getCountryCode(phoneNumber || "");
		const rawNumber = (phoneNumber || "")
			.replace(countryCode, "")
			.replace(/\D/g, "")
			.substr(0, 10);
		if (!rawNumber) return "";
		return getCountryFormat(countryCode)(rawNumber);
	};

	const handleOnInput = (event) => {
		const el = event.target;

		const rawNumber = el.value.replace(/\D/g, "").substr(0, 10);
		const cc = getCountryCode(value || "");
		value = `${cc}${rawNumber}`;

		const formatted = getFormattedNumber(value);
		inputValue = formatted;

		// If the inputType is not delete or arrow movement, snap cursor to end
		if (
			event.inputType !== "deleteContentBackward" &&
			event.inputType !== "deleteContentForward" &&
			event.inputType !== "insertFromPaste"
		) {
			requestAnimationFrame(() => {
				el.setSelectionRange(el.value.length, el.value.length);
			});
		}
	};
	const handleOnChange = (event) => {
		const rawNumber = event.target.value.replace(/\D/g, "").substr(0, 10);
		isValid = rawNumber ? isValidPhoneNumber(value || "") : true;
		handleChange(event);
	};

	const handleSelectChange = (event) => {
		const rawNumber = inputValue.replace(/\D/g, "").substr(0, 10);
		const cc = event.target.value;
		value = `${cc}${rawNumber}`;
		isValid = rawNumber ? isValidPhoneNumber(value || "") : true; // since I don't want any flags if there's no number in the text input
		handleChange(event);
	};

	$: inputValue = getFormattedNumber(value);
	$: countryCode = getCountryCode(value);
</script>

{#if browser}
	<div class="join">
		<select
			bind:value={countryCode}
			class={`select join-item w-auto`}
			on:change={handleSelectChange}
			{disabled}
			{tabindex}
			{key}
		>
			{#if readonly && countryCode}
				<option value={countryCode}>
					{`${countries.find((c) => c.code === countryCode).flag} ${countries.find((c) => c.code === countryCode).name} (${countryCode})`}
				</option>
			{:else}
				{#each countries as { code, name, flag }}
					<option value={code}>
						{code ? `${flag} ${name} (${code})` : ""}
					</option>
				{/each}
			{/if}
		</select>

		<input
			id={`${slugify(label)}-input`}
			name={`new ${label}`}
			{itemId}
			class={`input join-item w-auto`}
			type="tel"
			{key}
			bind:value={inputValue}
			on:input={handleOnInput}
			on:change={handleOnChange}
			autocomplete="off"
			{disabled}
			{readonly}
			{tabindex}
		/>
		<input id={`${slugify(label)}-input-value`} type="hidden" bind:value />
	</div>
{/if}
